import './Home.css'
import React from "react";

const Home = () => {
    return (
        <div>
            <h1 className="page-header">Welcome to New Beginnings <small>Come Worship With Us!</small></h1>

            <h3>Our Mission</h3>
            <p>We are a community of believers helping people FIND Jesus, KNOW Jesus, LOVE Jesus, and SHARE Jesus</p>
            <h3>Our Vision</h3>
            <p>To Make Christ-Like Disciples</p>
            <h3>Service Time</h3>
            <p>Sunday Morning at 10:30 am</p>
            <blockquote className="blockquote text-center">
                <p className="mb-0">For God so loved the world that He gave His one and only Son, that whoever believes in Him shall not parish but have eternal life</p>
                <footer className="blockquote-footer"><cite title="Source Title">John 3:16</cite></footer>
            </blockquote>
        </div>
    );
}

export default Home;